import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { LOADING } from 'constants/data';
import { getUser, getSignInLoadingStatus, getSignUpLoadingStatus } from 'store/selectors';

const PrivateRoute = ({ component: Component, skeleton: Skeleton, ...rest }) => {
  const { search } = useLocation();
  const user = useSelector(getUser);
  const singInLoadingStatus = useSelector(getSignInLoadingStatus);
  const singUpLoadingStatus = useSelector(getSignUpLoadingStatus);
  const hasToken = user.token || localStorage.getItem('mpToken');
  const isLoading = singInLoadingStatus === LOADING || singUpLoadingStatus === LOADING;

  return (
    <Route
      {...rest}
      render={props =>
        isLoading && Skeleton ? (
          <Skeleton />
        ) : hasToken ? (
          <Component {...props} />
        ) : (
          <Redirect to={`/auth/sign-in${search}`} />
        )
      }
    />
  );
};

export default PrivateRoute;
